import { PAGE_ID } from "stores/route/utils/types"
import { MenuItem } from "./types"
import i18n from "i18next"
import { COMPONENT_TYPE, GrowUnitComponent } from "types/Service"
import farmSo from "stores/farm"



/**
 * sottosezione FARM -> COMPONENTS
 */
export const ITEMS_GROWUNIT: MenuItem[] = [

	{ id: PAGE_ID.GROWUNIT_HOME, title: "MAIN", group: COMPONENT_TYPE.GROWUNIT, onlyNats: true },
	{ id: PAGE_ID.GROWUNIT_MAIN, title: "PLANT", group: COMPONENT_TYPE.GROWUNIT, onlyNats: true },
	{ id: PAGE_ID.GROWUNIT_LAYERS, title: "LAYERS", group: COMPONENT_TYPE.GROWUNIT, divider: true },

	{ id: PAGE_ID.GROWUNIT_FERTI, title: "ACTIONS", group: COMPONENT_TYPE.GROWUNIT, onlyNats: true },
	{ id: PAGE_ID.GROWUNIT_ADJ, title: "ADJUSTMENTS", group: COMPONENT_TYPE.GROWUNIT, onlyNats: true },
	{ id: PAGE_ID.GROWUNIT_LIGHTING, title: "LIGHTING", group: COMPONENT_TYPE.GROWUNIT, onlyNats: true },
	{
		id: PAGE_ID.GROWUNIT_LIGHTING_PS, title: "LIGHTING P.S.", group: COMPONENT_TYPE.GROWUNIT, onlyNats: true,
		isHidden: () => farmSo.state.select?.edgeServicesConfig?.guMenuItems?.some(item => item.code == "lighting-ps" && item.hidden) ?? false,
	},
	{
		id: PAGE_ID.GROWUNIT_CLIMATE, title: "CLIMATE", group: COMPONENT_TYPE.GROWUNIT, onlyNats: true,
		isHidden: () => !farmSo.state.select?.edgeServicesConfig?.guMenuItems?.some(item => item.code == "climate" && !item.hidden),
		// isHidden: () => {
		// 	const code = (<GrowUnitComponent>farmSo.state.componentSelect)?.links?.climate
		// 	return !!code
		// },
	},
	{ 
		id: PAGE_ID.COMPONENT_SCHEDULER, title: "SCHEDULER", group: COMPONENT_TYPE.GROWUNIT, onlyNats: true,
		isHidden: () => {
			const scheduler = (<GrowUnitComponent>farmSo.state.componentSelect)?.options?.scheduler
			return !scheduler
		},
	},	
	{ id: PAGE_ID.GROWUNIT_IRRIGATION, title: "IRRIGATION", group: COMPONENT_TYPE.GROWUNIT, onlyNats: true, divider: true, },


	{ id: PAGE_ID.GROWUNIT_PLC_ALERTS, title: "ALERTS", group: COMPONENT_TYPE.GROWUNIT, onlyNats: true },
	{ id: PAGE_ID.GROWUNIT_PLC_PROPERTIES, title: "PROPERTIES", group: COMPONENT_TYPE.GROWUNIT, onlyNats: true },
	{
		id: PAGE_ID.GROWUNIT_RECIPE, title: "RECIPE", group: COMPONENT_TYPE.GROWUNIT,
		isHidden: () => farmSo.state.select?.edgeServicesConfig?.guMenuItems?.some(item => item.code == "recipe" && item.hidden) ?? false,
	},


	{ id: PAGE_ID.COMPONENT_HVAC, title: "MAIN", group: COMPONENT_TYPE.HVAC, onlyNats: true },
	{ id: PAGE_ID.COMPONENT_HVAC_ALERTS, title: "PLC WARNING", group: COMPONENT_TYPE.HVAC, onlyNats: true },
	{ id: PAGE_ID.COMPONENT_HVAC_PROPERTIES, title: "PROPERTIES", group: COMPONENT_TYPE.HVAC, onlyNats: true },


	{ id: PAGE_ID.COMPONENT_GERMINATION, title: "MAIN", group: COMPONENT_TYPE.GERMINATOR, onlyNats: true },
	{ id: PAGE_ID.COMPONENT_GERMINATION_ALERTS, title: "PLC WARNING", group: COMPONENT_TYPE.GERMINATOR, onlyNats: true },
	{ id: PAGE_ID.COMPONENT_GERMINATION_PROPERTIES, title: "PROPERTIES", group: COMPONENT_TYPE.GERMINATOR, onlyNats: true },


	{ id: PAGE_ID.COMPONENT_OSMOTIC_WATER, title: "MAIN", group: COMPONENT_TYPE.OSMOTIC_WATER, onlyNats: true },
	{ id: PAGE_ID.COMPONENT_OSMOTIC_WATER_ALERTS, title: "PLC WARNING", group: COMPONENT_TYPE.OSMOTIC_WATER, onlyNats: true },
	{ id: PAGE_ID.COMPONENT_OSMOTIC_WATER_PROPERTIES, title: "PROPERTIES", group: COMPONENT_TYPE.OSMOTIC_WATER, onlyNats: true },


	{ id: PAGE_ID.COMPONENT_CO2, title: "MAIN", group: COMPONENT_TYPE.CO2, onlyNats: true },
	{ id: PAGE_ID.COMPONENT_CO2_ALERTS, title: "PLC WARNING", group: COMPONENT_TYPE.CO2, onlyNats: true },
	{ id: PAGE_ID.COMPONENT_CO2_PROPERTIES, title: "PROPERTIES", group: COMPONENT_TYPE.CO2, onlyNats: true },


	{ id: PAGE_ID.COMPONENT_CO2_PANEL, title: "MAIN", group: COMPONENT_TYPE.CO2_PANEL, onlyNats: true },


	{ id: PAGE_ID.COMPONENT_WATER_TREATMENT, title: "MAIN", group: COMPONENT_TYPE.WATER_TREATMENT, onlyNats: true },
	{ id: PAGE_ID.COMPONENT_WATER_TREATMENT_ALERTS, title: "PLC WARNING", group: COMPONENT_TYPE.WATER_TREATMENT, onlyNats: true },
	{ id: PAGE_ID.COMPONENT_WATER_TREATMENT_PROPERTIES, title: "PROPERTIES", group: COMPONENT_TYPE.WATER_TREATMENT, onlyNats: true },


	{ id: PAGE_ID.COMPONENT_THERMAL_POWER_PLANT, title: "MAIN", group: COMPONENT_TYPE.THERMAL_POWER_PLANT },
]

/**
 * macrosezione FARM
 */
const ITEMS_FARM: MenuItem[] = [

	/** MAP */
	{
		id: PAGE_ID.FARM_MAP, title: "HOME",
		isHidden: () => !farmSo.state.select?.mapConfig,
	},

	/** COMPONENTS */
	{ id: PAGE_ID.FARM_GROWUNITS, title: i18n.t("menu.farms.growUnits.label"), children: ITEMS_GROWUNIT, divider: true },

	{ id: PAGE_ID.FARM_PLANNER, title: i18n.t("menu.farms.planner") },
	{ id: PAGE_ID.FARM_TASKS, title: i18n.t("menu.farms.tasks") },
	{ id: PAGE_ID.FARM_CYCLES, title: i18n.t("menu.farms.cycles"), },
	{ id: PAGE_ID.FARM_ATTACH, title: "QUALITY", divider: true, },

	{ id: PAGE_ID.FARM_AI_PLANNING, title: i18n.t("menu.farms.productions"), onlyDebug: true, noReader: true },
	{ id: PAGE_ID.FARM_ALERTS, title: i18n.t("menu.farms.alerts") },
	{ id: PAGE_ID.FARM_BI, title: "YIELDS", divider: true },

	{ id: PAGE_ID.FARM_PLC_ALERTS, title: "PLC WARNING", onlyNats: true },
	{
		id: PAGE_ID.COMPONENT_POWER_MONITOR, title: "POWERS", onlyNats: true,
		isHidden: () => farmSo.getComponentsByType(COMPONENT_TYPE.POWERS).length == 0
	},
	{ id: PAGE_ID.FARM_METADATA, title: i18n.t("menu.metadata.label"), onlyNats: true, divider: true },

	// { title: "menu.farms.charts", id: PAGE_ID.FARM_CHARTS },
	// { title: "menu.farms.consoles", id: PAGE_ID.FARM_CONSOLES },
	{ id: PAGE_ID.FARM_TECHNICAL_DASHBOARDS, title: i18n.t("menu.farms.technicalDashboards") },
	{ id: PAGE_ID.FARM_BUSINESS_DASHBOARDS, title: i18n.t("menu.farms.businessDashboards") },
]

/**
 * macrosezione LIBRARY
 */
const ITEMS_LIBRARY: MenuItem[] = [
	// { id: PAGE_ID.FARMS, title: i18n.t("menu.farms.label"), children: ITEMS_FARM },
	{ id: PAGE_ID.RECIPES, title: i18n.t("menu.recipes"), subIds: [PAGE_ID.RECIPES_DETAIL] },
	{ id: PAGE_ID.CROPS, title: i18n.t("menu.crops"), subIds: [PAGE_ID.CROPS_DETAIL], onlyDebug: true },
	{ id: PAGE_ID.CROPS_RECIPES, title: i18n.t("menu.crops_recipes"), subIds: [PAGE_ID.CROPS_DETAIL] },
	{ id: PAGE_ID.PRODUCTS, title: i18n.t("menu.products"), subIds: [PAGE_ID.PRODUCTS_DETAIL], onlyAdmin: true },
	// { id: PAGE_ID.ALARMS, title: i18n.t("menu.alarms"), onlyAdmin: true, subIds: [PAGE_ID.ALARMS_DETAIL] },
	// { id: PAGE_ID.ROOT, title: i18n.t("menu.root") },
	// { id: PAGE_ID.ZW, title: i18n.t("menu.zw") },
]

/**
 * macrosezione LIBRARY
 */
const ITEMS_SETTINGS: MenuItem[] = [
	{ id: PAGE_ID.ALARMS, title: i18n.t("menu.alarms"), onlyAdmin: true, subIds: [PAGE_ID.ALARMS_DETAIL] },
]

/**
 * macrosezione LABS
 */
const ITEMS_LABS: MenuItem[] = [
	{ id: PAGE_ID.LABS_SOLUTIONS, title: "SOLUTIONS" },
	{ id: PAGE_ID.LABS_PLANNER, title: "PLANNER" },
	{ id: PAGE_ID.LABS_GPT, title: "ZERO-GPT" },
]

/**
 * ROOT del MAIN-MENU
 */
export const ITEMS_MAIN: MenuItem[] = [
	{ id: PAGE_ID.LIBRARY, title: "LIBRARY", children: ITEMS_LIBRARY },
	{ id: PAGE_ID.FARMS, title: i18n.t("menu.farms.label"), children: ITEMS_FARM },
	{ id: PAGE_ID.SETTINGS, title: "SETTINGS", children: ITEMS_SETTINGS },
	{ id: PAGE_ID.LABS, title: "LABS", children: ITEMS_LABS },
]